export default {"src":"/_next/static/media/VectorHIW.be5444ab.svg","height":105,"width":1431,"blurWidth":0,"blurHeight":0};